module.exports = {
	"pagination": {
		"ListIdentityPools": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "IdentityPools"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 1862
// module chunks = 0